import { MultiPartFormHolderService } from '@app/finxone-web-frontend/app/lib/services/multipart-holder/multipart-form-holder.service';
import { onboardIndividualFormStages } from '@app/finxone-web-frontend/app/lib/utils/onboarding/utils';

const formService = new MultiPartFormHolderService();
formService.setFormStages(onboardIndividualFormStages);

export const mockFormService = formService;
